<template>
  <div class="receiver-container">
    <img
      height="12"
      width="12"
      class="icon-receiver"
      :src="typeImage[receiver.icon_type]"
    >
    <div class="receiver-text" :style="styles">{{ receiver.name }}</div>
  </div>
</template>

<script>
import { lockIcon, groupIcon, worldIcon } from '@/assets/img/index.js'
import { convertEmToPixels } from '@/helper/helper'

export default {
  name: 'Receiver',
  props: {
    receiver: Object
  },
  data: () => ({
    typeImage: {
      global: worldIcon,
      public: worldIcon,
      private: lockIcon,
      group: groupIcon
    }
  }),
  computed: {
    styles () {
      const result = convertEmToPixels(14)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/publication/receiver.vue